import { all, takeEvery, put, fork, select } from 'redux-saga/effects';
import { createBrowserHistory } from 'history';
import {
  getToken,
  clearToken,
  getForbidToken,
  clearForbidToken,
  getModules,
  getIdentity,
  clearModules,
  clearIdentity,
  clearTopic,
  getEnv,
  clearEnv,
  clearMqttToken,
  getMqttToken,
  getCustomAuth,
  clearCustomAuth,
  getCustomModule,
  clearCustomModule,
  getRoles,
  clearRoles,
  clearMerchantList,
  clearSelectedMerchant,
  clearSelectedMerchantName,
  getMqOpts,
  clearMqOpts,
} from '@iso/lib/helpers/utility';
import actions from './actions';
import mqttAction from '../mqtt/actions';
import { PUT, fetch, post, get } from '@iso/lib/helpers/resApiRequestor';
import { pushDataToApp } from '@iso/lib/helpers/mobileAppCommKit';
import { getErrorCode } from '@iso/lib/helpers/isDisconnected';

const history = createBrowserHistory();
const apiUrl = process.env.REACT_APP_API_URL;

let headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json'
};

export function* generateLoginOtp() {
  yield takeEvery('GENERATE_LOGIN_OTP', function* ({ payload }) {
    try {
      yield put({
        type: actions.GENERATING_LOGIN_OTP
      });

      yield put({
        type: actions.KICKED_OUT_CLEAR
      });

      yield put({
        type: actions.CLEAR_ERROR
      });

      const apiResult = yield generateLoginOtpAPI(payload);

      if (apiResult) {
        const result = apiResult.data ? apiResult.data : apiResult;
        if (result.success) {
          yield put({
            type: actions.GENERATE_LOGIN_OTP_SUCCESS,
            result: result
          });
        } else {
          if (result && (result.message === 'Unauthorized' || result.message === 'Invalid User Credentials')) {
            yield put({
              type: actions.LOGIN_ERROR,
              error: 'INVALID_AUTH'
            });
          } else if (result && result.message === 'Account not verified') {
            yield put({
              type: actions.LOGIN_ERROR,
              error: 'NOT_VERIFIED'
            });
          } else if (result && result.message === 'Invalid Mobile') {
            yield put({
              type: actions.LOGIN_ERROR,
              error: 'INVALID_MOBILE'
            });
          } else if (result && result.message === 'Unavailable') {
            yield put({
              type: actions.LOGIN_ERROR,
              error: 'ACCESS_UNAVAILABLE'
            });
          } else if (result && result.message === 'OTP already expired') {
            yield put({
              type: actions.LOGIN_ERROR,
              error: 'OTP_EXPIRED'
            });
          } else if (result && result.message === 'User Locked') {
            yield put({
              type: actions.LOGIN_ERROR,
              error: 'USER_BLOCKED'
            });
          } else {
            yield put({
              type: actions.LOGIN_ERROR,
              error: 'Login Error'
            });
          }
          yield put({
            type: actions.GENERATE_LOGIN_OTP_FAILED
          });
        }
      } else {
        yield put({
          type: actions.LOGIN_ERROR,
          error: 'INVALID_AUTH'
        });
        yield put({
          type: actions.GENERATE_LOGIN_OTP_FAILED
        });
      }
    } catch (e) {
      // Modification: to handle network error and API disconnections
      //const isOffline = !navigator.onLine || /network|fetch/i.test(e.message);
      //const LoginErrorCode = isOffline ? 'NETWORK_ERROR' : 'API_FAILURE';
      const LoginErrorCode = getErrorCode(e);

      yield put({
        type: actions.LOGIN_ERROR,
        error: LoginErrorCode
      });
      yield put({
        type: actions.GENERATE_LOGIN_OTP_FAILED
      });
    }
  });
}

export function* decodeRequest() {
  yield takeEvery('DECODE_VALUE', function* ({ payload }) {
    try {
      const apiResult = yield decryptMqDataAPI(payload)

      const result = apiResult.data

      if (!result.success) {
        yield put({
          type: actions.DECODE_VALUE_FAILED,
          error: 'DECODE_ERROR'
        });
        return;
      }
      yield put({
        type: actions.DECODE_VALUE_SUCCESS,
        result: result.value
      });
    } catch (e) {
      console.error("Something went wrong")
      yield put({
        type: actions.DECODE_VALUE_FAILED,
        error: 'DECODE_ERROR'
      });
    }
  });
}

export function* loginRequest() {
  yield takeEvery('LOGIN_REQUEST', function* ({ payload }) {
    try {
      const data = yield select(state => state.Auth.generateLoginOtp);
      yield put({
        type: actions.GENERATE_LOGIN_OTP_SUCCESS,
        result: { ...data, otp: payload.otp }
      });

      yield put({
        type: actions.KICKED_OUT_CLEAR
      });

      yield put({
        type: actions.CLEAR_ERROR
      });

      yield put({
        type: actions.SET_LOADING,
        loading: true
      });

      const apiResult = yield login(payload);

      if (apiResult) {
        const result = apiResult.data ? apiResult.data : apiResult;
        if (result.success && result.token && result.modules && result.modules.length > 0) {
          let topic;
          topic = `/cosmos-system/${result.user.auth_id}`;

          yield put({
            type: actions.LOGIN_SUCCESS,
            token: result.token,
            identity: JSON.stringify(result.user),
            modules: JSON.stringify(result.modules),
            roles: JSON.stringify(result.roles),
            profile: 'Profile',
            env: result.env,
            topic,
            mqOpts: result.mqOpts
          });

          yield put({
            type: mqttAction.CONNECT
          });

          yield put({
            type: actions.SET_LOADING,
            loading: false
          });
        } else {
          if (result && result.message === 'Unauthorized') {
            yield put({
              type: actions.LOGIN_ERROR,
              error: 'INVALID_AUTH'
            });
          } else if (result && result.message === 'Account not verified') {
            yield put({
              type: actions.LOGIN_ERROR,
              error: 'NOT_VERIFIED'
            });
          } else if (result && result.message === 'Invalid OTP') {
            yield put({
              type: actions.LOGIN_ERROR,
              error: 'INVALID_OTP'
            });
          } else if (result && result.message === 'Unavailable') {
            yield put({
              type: actions.LOGIN_ERROR,
              error: 'ACCESS_UNAVAILABLE'
            });
          } else if (result && result.message === 'User Locked') {
            yield put({
              type: actions.LOGIN_ERROR,
              error: 'OTP_LOCKED'
            });
          } else {
            yield put({
              type: actions.LOGIN_ERROR,
              error: 'Login Error'
            });
          }

          yield put({
            type: actions.SET_LOADING,
            loading: false
          });
        }
      } else {
        yield put({
          type: actions.LOGIN_ERROR,
          error: 'Invalid Request'
        });
        yield put({
          type: actions.SET_LOADING,
          loading: false
        });
      }
    } catch (e) {
      yield put({
        type: actions.SET_LOADING,
        loading: false
      });
      yield put({
        type: actions.LOGIN_ERROR,
        error: 'Invalid Request'
      });
    }
  });
}

export function* signupRequest() {
  yield takeEvery('SIGNUP', function* ({ payload }) {
    yield put({
      type: actions.CLEAR_ERROR
    });
    yield put({
      type: actions.SET_LOADING,
      loading: true
    });
    try {
      const apiResult = yield signup(payload);
      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.SET_LOADING,
          loading: false
        });
        yield put({
          type: actions.CLEAR_ERROR
        });
        window.location.href = result.url;
      } else {
        yield put({
          type: actions.SIGNUP_ERROR,
          error: `Registration failed. ${result.message}`
        });
        yield put({
          type: actions.SET_LOADING,
          loading: false
        });
      }
    } catch (e) {
      yield put({
        type: actions.SIGNUP_ERROR,
        error: 'Registration failed'
      });
      yield put({
        type: actions.SET_LOADING,
        loading: false
      });
    }
  });
}

export function* generateForgotOtp() {
  yield takeEvery('GENERATE_FORGOT_OTP', function* ({ payload }) {
    const isLoading = yield select(state => state.Auth.isGeneratingForgotOtp);
    if (isLoading) return;
    try {

      yield put({
        type: actions.FORGOT_CLEAR
      });

      yield put({
        type: actions.GENERATING_FORGOT_OTP
      });

      const apiResult = yield generateForgotOtpAPI(payload);
      if (apiResult) {
        const result = apiResult.data ? apiResult.data : apiResult;
        if (result.success) {
          yield put({
            type: actions.GENERATE_FORGOT_OTP_SUCCESS,
            result: result
          });
        } else {
          if (result && (result.message === 'Unauthorized' || result.message === 'Invalid User Credentials')) {
            // added 'Invalid User Credentials' to match api message for unregistered email
            yield put({
              type: actions.FORGOT_ERROR,
              error: 'INVALID_AUTH'
            });
          } else if (result && result.message === 'Account not verified') {
            yield put({
              type: actions.FORGOT_ERROR,
              error: 'NOT_VERIFIED'
            });
          } else if (result && result.message === 'Invalid Mobile') {
            yield put({
              type: actions.FORGOT_ERROR,
              error: 'INVALID_MOBILE'
            });
          } else if (result && result.message === 'Unavailable') {
            yield put({
              type: actions.FORGOT_ERROR,
              error: 'ACCESS_UNAVAILABLE'
            });
          } else if (result && result.message === 'User Locked') {
            yield put({
              type: actions.FORGOT_ERROR,
              error: 'USER_BLOCKED'
            });
          } else {
            yield put({
              type: actions.FORGOT_ERROR,
              error: 'Forgot Error'
            });
          }
          yield put({
            type: actions.KICKED_OUT_CLEAR
          });
          yield put({
            type: actions.GENERATE_FORGOT_OTP_FAILED
          });
        }
      } else {

        yield put({
          type: actions.FORGOT_ERROR,
          error: 'INVALID_AUTH'
        });
        yield put({
          type: actions.KICKED_OUT_CLEAR
        });
        yield put({
          type: actions.GENERATE_FORGOT_OTP_FAILED
        });
      }
    } catch (e) {
      const forgotErrorCode = getErrorCode(e);

      yield put({
        type: actions.FORGOT_ERROR,
        error: forgotErrorCode
      });
      yield put({
        type: actions.GENERATE_FORGOT_OTP_FAILED
      });
    }
  });
}

export function* forgotPassword() {
  yield takeEvery('FORGOT_PASSWORD', function* ({ payload }) {
    const data = yield select(state => state.Auth.generateForgotOtp);
    yield put({
      type: actions.GENERATE_FORGOT_OTP_SUCCESS,
      result: { ...data, otp: payload.otp }
    });
    yield put({
      type: actions.CLEAR_ERROR
    });
    yield put({
      type: actions.SET_LOADING,
      loading: true
    });

    try {
      const apiResult = yield forgotPasswordReq(payload);
      const result = apiResult.data;
      if (result.success) {
        if (result && result.message === 'Invalid OTP') {
          yield put({
            type: actions.FORGOT_ERROR,
            error: 'INVALID_OTP'
          });
        } else if (result && result.message === 'User Locked') {
          yield put({
            type: actions.FORGOT_ERROR,
            error: 'OTP_LOCKED'
          });
        } else {
          yield put({
            type: actions.FORGOT_ERROR,
            error: null
          });
          yield put({
            type: actions.FORGOT_PASSWORD_DONE,
            success: true
          });
        }

        yield put({
          type: actions.SET_LOADING,
          loading: false
        });
      } else {
        yield put({
          type: actions.FORGOT_PASSWORD_DONE,
          success: false
        });
        yield put({
          type: actions.FORGOT_ERROR,
          error: 'Invalid Request'
        });
        yield put({
          type: actions.SET_LOADING,
          loading: false
        });
      }
    } catch (e) {
      yield put({
        type: actions.SET_LOADING,
        loading: false
      });
      yield put({
        type: actions.FORGOT_ERROR,
        error: 'Invalid Request'
      });
    }
  });
}

export function* loginSuccess() {
  yield takeEvery(actions.LOGIN_SUCCESS, function* (payload) {
    yield localStorage.setItem('idToken', payload.token);
    yield localStorage.setItem('modules', payload.modules);
    yield localStorage.setItem('identity', payload.identity);
    yield localStorage.setItem('topic', payload.topic);
    yield localStorage.setItem('env', payload.env);
    yield localStorage.setItem('customAuthorizations', payload.customAuthorizations);
    yield localStorage.setItem('customModules', payload.customModules);
    yield localStorage.setItem('roles', payload.roles);
    yield localStorage.setItem('mqOpts', payload.mqOpts);
    pushDataToApp('idToken', payload.token);
    pushDataToApp('modules', payload.modules);
    pushDataToApp('identity', payload.identity);
    pushDataToApp('topic', payload.topic);
    pushDataToApp('env', payload.env);
    pushDataToApp('customAuthorizations', payload.customAuthorizations);
    pushDataToApp('customModules', payload.customModules);
    pushDataToApp('roles', payload.roles);
    pushDataToApp('mqOpts', payload.mqOpts);
    yield put({
      type: actions.RESET_SECOND_TIMER,
      secondTimer: 900
    });
  });
}

export function* subModuleLoad() {
  yield takeEvery(actions.SUBMODULES, function* (data) {
    yield localStorage.setItem(
      'modules',
      typeof data.payload === 'string' ? JSON.parse(data.payload) : data.payload
    );
  });
}

export function* loginError() {
  yield takeEvery(actions.LOGIN_ERROR, function* () { });
}

export function* logout() {
  yield takeEvery(actions.LOGOUT, function* () {
    yield clearToken();
    yield clearModules();
    yield clearIdentity();
    yield clearTopic();
    yield clearEnv();
    yield clearMqttToken();
    yield clearCustomAuth();
    yield clearCustomModule();
    yield clearForbidToken();
    yield clearRoles();
    yield clearMerchantList();
    yield clearSelectedMerchant();
    yield clearSelectedMerchantName();
    yield clearMqOpts();
    yield put({
      type: actions.RESET_SECOND_TIMER,
      secondTimer: 0
    });
    yield put({
      type: mqttAction.DISCONNECT_MQTT
    });
    history.push('/');
  });
}

export function* kickedOutClear() {
  yield takeEvery(actions.KICKED_OUT_CLEAR, function* () {
    yield clearForbidToken();
  });
}

export function* updateActiveRoleModules() {
  yield takeEvery(actions.UPDATE_ACTIVE_ROLE_MODULES, function* (data) {
    yield localStorage.setItem('customModules', JSON.stringify(data.payload));
  });
}

export function* checkAuthorization() {
  yield takeEvery(actions.CHECK_AUTHORIZATION, function* () {
    const forbidToken = getForbidToken().get('forbidToken');
    const token = getToken().get('idToken');
    const modules = getModules().get('modules');
    const identity = getIdentity().get('identity');
    const topic = getIdentity().get('topic');
    const env = getEnv().get('env');
    const mqttToken = getMqttToken().get('mqttToken');
    const customAuthorizations = getCustomAuth().get('customAuthorizations');
    const customModules = getCustomModule().get('customModules');
    const roles = getRoles().get('roles');
    const mqOpts = getMqOpts().get('mqOpts');
    if (token) {
      yield put({
        type: actions.LOGIN_SUCCESS,
        token,
        identity,
        modules,
        profile: 'Profile',
        env,
        customAuthorizations,
        customModules,
        roles,
        topic,
        mqOpts
      });

      yield put({
        type: actions.LOGIN_VALIDATOR,
        token: mqttToken ? mqttToken : token
      });

      yield put({
        type: mqttAction.CONNECT
      });
    }
    if (forbidToken) {
      yield put({
        type: actions.KICKED_OUT
      });
      yield put({
        type: actions.LOGOUT
      });
    }
  });
}

export function* getResetPassUrl() {
  yield takeEvery('FETCH_RESET_PASSWORD_URL', function* () {
    try {
      const apiResult = yield fetchResetPassUrl();
      const result = apiResult.data;
      yield put({
        type: actions.FETCHING_RESET_PASSWORD_URL
      });
      yield put({
        type: actions.FETCHED_RESET_PASSWORD_URL,
        resetPassUrl: result
      });
    } catch (error) {
      yield put({
        type: actions.FETCH_RESET_PASSWORD_URL_FAILED
      });
    }
  });
}

export function* changePassword() {
  yield takeEvery('CHANGE_PASSWORD', function* ({ payload }) {
    try {
      yield put({
        type: actions.CHANGING_PASSWORD
      });
      const roleHeaderAuth = yield getRoleHeader();

      const apiResult = yield changePasswordDone(payload, roleHeaderAuth);
      const result = apiResult.data;

      if (result.success === true) {
        yield put({
          type: actions.CHANGED_PASSWORD,
          message: apiResult.data.message,
          user: result
        });
      } else {
        yield put({
          type: actions.CHANGED_PASSWORD_FAILED,
          payload: result.message
        });
      }
    } catch (error) {
      yield put({
        type: actions.CHANGED_PASSWORD_FAILED,
        messsage: 'Failed to change password.'
      });
    }
  });
}

export function* updateUserNotificationData() {
  yield takeEvery('UPDATE_USER_NOTIFICATION', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.UPDATING_USER_NOTIFICATION,
        loading: true
      });
      const state = yield select();
      const identity = state.Auth.identity;
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield updateUserNotificationAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield localStorage.setItem('identity', JSON.stringify({ ...identity, ...payload }));
        yield put({
          type: actions.UPDATE_USER_NOTIFICATION_SUCCESS,
          loading: false,
          payload: {
            ...identity,
            ...payload
          },
          message: result.message
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.UPDATE_USER_NOTIFICATION_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.UPDATE_USER_NOTIFICATION_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.UPDATE_USER_NOTIFICATION_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* updateUserESignature() {
  yield takeEvery(actions.UPDATE_USER_E_SIGNATURE, function* ({ payload , resolve, reject  }) {
    try {
      yield put({
        type: actions.UPDATING_USER_E_SIGNATURE,
        loading: true
      });
      const state = yield select();
      const identity = state.Auth.identity;
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield updateUserESignatureAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield localStorage.setItem(
          'identity',
          JSON.stringify({ ...identity, e_signature: result?.data })
        );
        yield put({
          type: actions.UPDATE_USER_E_SIGNATURE_SUCCESS,
          loading: false,
          payload: {
            ...identity,
            e_signature: result?.data
          },
          message: result.message
        });
        if (resolve) resolve(result.data);
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.UPDATE_USER_E_SIGNATURE_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.UPDATE_USER_E_SIGNATURE_FAILED,
            message: result.message,
            loading: false
          });
        }
        if (reject) reject(result.message || 'Failed to upload file');
      }
    } catch (error) {
      yield put({
        type: actions.UPDATE_USER_E_SIGNATURE_FAILED,
        message: 'Failed to process request',
        loading: false
      });
      if (reject) reject(error);
    }
  });
}

export function* deleteUserESignature() {
  yield takeEvery(actions.DELETE_USER_E_SIGNATURE, function* ({ payload, id }) {
    try {
      yield put({
        type: actions.DELETE_USER_E_SIGNATURE_LOADING,
        loading: true
      });
      const state = yield select();
      const identity = state.Auth.identity;
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield deleteUserESignatureAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield localStorage.setItem('identity', JSON.stringify({ ...identity, e_signature: null }));
        yield put({
          type: actions.DELETE_USER_E_SIGNATURE_SUCCESS,
          loading: false,
          payload: {
            ...identity,
            e_signature: null
          },
          message: result.message
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.DELETE_USER_E_SIGNATURE_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.DELETE_USER_E_SIGNATURE_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.DELETE_USER_E_SIGNATURE_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchUserESignatureURL() {
  yield takeEvery(actions.FETCH_USER_E_SIGNATURE_URL, function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCH_USER_E_SIGNATURE_URL_LOADING,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchUserESignatureURLAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_USER_E_SIGNATURE_URL_SUCCESS,
          loading: false,
          message: 'Attachment exported successfully.',
          result: result?.data?.url
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_USER_E_SIGNATURE_URL_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.FETCH_USER_E_SIGNATURE_URL_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_FILE_ACCESS_URL_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* updateUserOTPSending() {
  yield takeEvery('UPDATE_OTP_SENDING', function* ({ payload }) {
    try {
      yield put({
        type: actions.UPDATING_OTP_SENDING,
        loading: true
      });
      const state = yield select();
      const identity = state.Auth.identity;
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield updateUserOTPSendingAPI(payload, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield localStorage.setItem('identity', JSON.stringify({ ...identity, ...payload }));
        yield put({
          type: actions.UPDATE_OTP_SENDING_SUCCESS,
          loading: false,
          payload: {
            ...identity,
            ...payload
          },
          message: result.message
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.UPDATE_OTP_SENDING_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.UPDATE_OTP_SENDING_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.UPDATE_OTP_SENDING_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchChangePasswordDetails() {
  yield takeEvery('FETCH_CHANGE_PASSWORD_DETAILS', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_CHANGE_PASSWORD_DETAILS,
        loading: true
      });

      const apiResult = yield fetchChangePasswordDetailsAPI(payload);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_CHANGE_PASSWORD_DETAILS_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.FETCH_CHANGE_PASSWORD_DETAILS_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_CHANGE_PASSWORD_DETAILS_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* submitChangePasswordData() {
  yield takeEvery('SUBMIT_CHANGE_PASSWORD_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.SUBMITTING_CHANGE_PASSWORD_DATA,
        loading: true
      });

      const apiResult = yield submitChangePasswordDataAPI(payload);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.SUBMIT_CHANGE_PASSWORD_DATA_SUCCESS,
          loading: false,
          message: result.message
        });

        yield put({
          type: actions.FETCH_CHANGE_PASSWORD_DETAILS,
          payload: payload.change_password_token
        });
      } else {
        yield put({
          type: actions.SUBMIT_CHANGE_PASSWORD_DATA_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.SUBMIT_CHANGE_PASSWORD_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

function* getRoleHeader() {
  const state = yield select();
  const identity = state.Auth.identity;
  const currentPage = state.App.currentPage;
  const currentAction = state.App.currentAction;
  if (currentAction) {
    return `${identity.role_id}:${currentPage.id}:${currentAction.id}`;
  } else {
    return `${identity.role_id}:${currentPage.id}`;
  }
}

function changePasswordDone(payload, roleAuth) {
  const data = {
    old_password: payload.oldPassword,
    new_password: payload.newPassword,
    retype_password: payload.retypePassword
  };

  return post(`change-password/auth`, data, null, null, roleAuth);
}

function generateLoginOtpAPI(data) {
  return fetch(`${apiUrl}/auth/generate-otp`, {
    headers: headers,
    method: 'POST',
    data
  });
}

function decryptMqDataAPI(data) {
  return fetch(`${apiUrl}/auth/connect`, {
    headers: headers,
    method: 'POST',
    data
  });
}

function generateForgotOtpAPI(data) {
  return fetch(`${apiUrl}/auth/generate-forgot-otp`, {
    headers: headers,
    method: 'POST',
    data
  });
}

function login(data) {
  return fetch(`${apiUrl}/auth/login`, {
    headers: headers,
    method: 'POST',
    data
  });
}

function signup(data) {
  return fetch(`${apiUrl}/registrationbizaccounts/pre_register`, {
    headers: headers,
    method: 'POST',
    data
  });
}

function forgotPasswordReq(data) {
  return PUT(`forgot-password/auth`, data, null, null);
}

function fetchResetPassUrl() {
  return fetch(`${apiUrl}/redirect_url/get_reset_password_url`, {
    headers: headers,
    method: 'get'
  });
}

function updateUserNotificationAPI(data, id, roleAuth) {
  return PUT(`edit-notification/auth`, data, null, roleAuth);
}

function updateUserESignatureAPI(data, roleAuth) {
  return PUT(`e-signatures`, data, null, roleAuth);
}

function deleteUserESignatureAPI(data, roleAuth) {
  return PUT(`e-signatures/delete`, data, null, roleAuth);
}

function fetchUserESignatureURLAPI(payload, roleAuth) {
  return post(`e-signatures/access-url`, payload, null, null, roleAuth);
}

function updateUserOTPSendingAPI(data, roleAuth) {
  return PUT(`edit-otp-sending/auth`, data, null, roleAuth);
}

function fetchChangePasswordDetailsAPI(id) {
  return get(`change_password_links/${id}`, null, null, null, null, null);
}

function submitChangePasswordDataAPI(data) {
  return post(`process/change-password-details`, data, null, null, null);
}

export default function* rootSaga() {
  yield all([
    fork(checkAuthorization),
    fork(loginRequest),
    fork(signupRequest),
    fork(forgotPassword),
    fork(loginSuccess),
    fork(subModuleLoad),
    fork(loginError),
    fork(logout),
    fork(kickedOutClear),
    fork(updateActiveRoleModules),
    fork(getResetPassUrl),
    fork(changePassword),
    fork(updateUserNotificationData),
    fork(updateUserESignature),
    fork(deleteUserESignature),
    fork(fetchUserESignatureURL),
    fork(generateLoginOtp),
    fork(updateUserOTPSending),
    fork(generateForgotOtp),
    fork(fetchChangePasswordDetails),
    fork(submitChangePasswordData),
    fork(decodeRequest)
  ]);
}
